import { ca } from '@cian/analytics';

import { getDeveloperContactsLabel } from 'shared/serp/components/header/developers_contacts';

interface ITrackOpenChatParams {
  newbuildingId: number;
  placeType: string | undefined;
  source?: string;
}

export function trackOpenChat({ newbuildingId, placeType, source }: ITrackOpenChatParams) {
  ca('eventSite', {
    action: 'open',
    category: 'Message_popup',
    label: getDeveloperContactsLabel(null),
    name: 'oldevent',
    products: [{ id: newbuildingId, offerType: 'JK' }],
    page: {
      extra: {
        type: placeType,
        source,
      },
    },
  });
}
